module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.data,
    staticStyle: {
      "background": "#DFC8E4"
    },
    attrs: {
      "id": "library_background",
      "width": "100%",
      "viewBox": "0 0 1280 572"
    }
  }, [_c('g', {
    staticClass: "library_background"
  }, [_c('path', {
    attrs: {
      "d": "M36,238 L631,238 C633.761424,238 636,240.238576 636,243 L636,506 L36,506 L36,238 Z",
      "id": "library_shelf_bg1_4",
      "fill": "#AB86B2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51,420 L621,420 C623.761424,420 626,422.238576 626,425 L626,496 L557.15625,496 L557.15625,484.38676 L544.787109,484.38676 L544.787109,480.104549 L549.15625,480.104549 L549.15625,475.755932 L489.083984,475.755932 L489.083984,434.580299 L471.001953,434.580299 L471.001953,427.00806 L458.847656,427.00806 L458.847656,439.105673 L448.269531,439.105673 L448.269531,434.580299 L434.261719,434.580299 L434.261719,424.000258 L404.029297,424.000258 L404.029297,444.256045 L393.869141,444.256045 L393.869141,427.00806 L383.265625,427.00806 L383.265625,436.922087 L352.15625,436.922087 L352.15625,427.00806 L336,427.00806 L336,439.013733 L321.193359,439.105673 L321.193359,431.44945 L314.34375,431.44945 L314.34375,447.789236 L296.748047,447.789236 L296.748047,436.922087 L278.259766,436.922087 L278.259766,427.00806 L228.267578,427.00806 L228.267578,442.148631 L211.873047,442.148631 L211.873047,434.580299 L194.019531,434.580299 L194.019531,427.00806 L180.039062,427.00806 L180.039062,439.105673 L165.263672,439.105673 L165.263672,449.826338 L113.150391,449.826338 L113.150391,444.256045 L99.5957031,444.256045 L99.5957031,449.826338 L85.4718007,449.826338 L85.4718007,439.013733 L68.8476562,439.105673 L68.8476563,461.935669 L57.703125,461.935669 L57.703125,449.826338 L46,449.826338 L46,425 C46,422.238576 48.2385763,420 51,420 Z",
      "id": "library_shelf_bg1_3",
      "fill": "#9F79A6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M621,334 L51,334 C48.2385763,334 46,336.238576 46,339 L46,410 L114.84375,410 L114.84375,398.386719 L127.212891,398.386719 L127.212891,394.104492 L122.84375,394.104492 L122.84375,389.755859 L182.916016,389.755859 L182.916016,348.580078 L200.998047,348.580078 L200.998047,341.007812 L213.152344,341.007812 L213.152344,353.105469 L223.730469,353.105469 L223.730469,348.580078 L237.738281,348.580078 L237.738281,338 L267.970703,338 L267.970703,358.255859 L278.130859,358.255859 L278.130859,341.007812 L288.734375,341.007812 L288.734375,350.921875 L319.84375,350.921875 L319.84375,341.007812 L336,341.007812 L336,353.013529 L350.806641,353.105469 L350.806641,345.449219 L357.65625,345.449219 L357.65625,361.789062 L375.251953,361.789062 L375.251953,350.921875 L393.740234,350.921875 L393.740234,341.007812 L443.732422,341.007812 L443.732422,356.148438 L460.126953,356.148438 L460.126953,348.580078 L477.980469,348.580078 L477.980469,341.007812 L491.960938,341.007812 L491.960938,353.105469 L506.736328,353.105469 L506.736328,363.826172 L558.849609,363.826172 L558.849609,358.255859 L572.404297,358.255859 L572.404297,363.826172 L586.528199,363.826172 L586.528199,353.013529 L603.152344,353.105469 L603.152344,375.935547 L614.296875,375.935547 L614.296875,363.826172 L626,363.826172 L626,339 C626,336.238576 623.761424,334 621,334 Z",
      "id": "library_shelf_bg1_2",
      "fill": "#9F79A6",
      "transform": "translate(336.000000, 372.000000) scale(-1, 1) translate(-336.000000, -372.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M621,248 L51,248 C48.2385763,248 46,250.238576 46,253 L46,324 L149.84375,324 L182.916016,274.413086 L182.916016,262.580078 L197.998047,262.580078 L197.998047,255.007812 L210.152344,255.007812 L210.152344,267.105469 L223.730469,267.105469 L223.730469,262.580078 L237.738281,262.580078 L237.738281,252 L267.970703,252 L267.970703,272.255859 L278.130859,272.255859 L278.130859,255.007812 L288.734375,255.007812 L288.734375,264.921875 L319.84375,264.921875 L319.84375,255.007812 L336,255.007812 L336,267.013529 L350.806641,267.105469 L350.806641,259.449219 L357.65625,259.449219 L357.65625,275.789062 L375.251953,275.789062 L375.251953,264.921875 L393.740234,264.921875 L393.740234,255.007812 L443.732422,255.007812 L443.732422,270.148438 L460.126953,270.148438 L460.126953,262.580078 L477.980469,262.580078 L477.980469,255.007812 L491.960938,255.007812 L491.960938,267.105469 L506.736328,267.105469 L506.736328,277.826172 L558.849609,277.826172 L558.849609,272.255859 L572.404297,272.255859 L572.404297,277.826172 L586.528199,277.826172 L586.528199,267.013529 L603.152344,267.105469 L603.152344,289.935547 L614.296875,289.935547 L614.296875,277.826172 L626,277.826172 L626,253 C626,250.238576 623.761424,248 621,248 Z",
      "id": "library_shelf_bg1_1",
      "fill": "#9F79A6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M661,306 L1050,306 C1052.76142,306 1055,308.238576 1055,311 L1055,506 L656,506 L656,311 C656,308.238576 658.238576,306 661,306 Z",
      "id": "library_shelf_bg2_3",
      "fill": "#AB86B2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1036,411 L656,411 C653.238576,411 651,413.503671 651,416.592105 L651,427.306666 L682.970703,427.306666 L682.970703,438.128264 L693.130859,438.128264 L693.130859,418.837685 L703.734375,418.837685 L703.734375,429.925781 L734.84375,429.925781 L734.84375,418.837685 L751,418.837685 L751,432.265131 L765.806641,432.367958 L765.806641,423.805047 L772.65625,423.805047 L772.65625,442.079873 L790.251953,442.079873 L790.251953,429.925781 L808.740234,429.925781 L808.740234,418.837685 L858.732422,418.837685 L858.732422,435.771279 L875.126953,435.771279 L875.126953,427.306666 L892.980469,427.306666 L892.980469,418.837685 L906.960938,418.837685 L906.960938,432.367958 L921.736328,432.367958 L921.736328,444.358219 L973.849609,444.358219 L973.849609,438.128264 L987.404297,438.128264 L987.404297,444.358219 L1001.5282,444.358219 L1001.5282,432.265131 L1018.15234,432.367958 L1018.15234,457.901598 L1029.29688,457.901598 L1029.29688,444.358219 L1041,444.358219 L1041,416.592105 C1041,413.503671 1038.76142,411 1036,411 Z",
      "id": "library_shelf_bg2_2",
      "fill": "#9F79A6",
      "transform": "translate(846.000000, 434.450799) scale(-1, 1) translate(-846.000000, -434.450799) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1040,316 L671,316 C668.238576,316 666,318.238576 666,321 L666,401 L709.84375,401 L742.916016,345.540951 L742.916016,332.306666 L757.998047,332.306666 L757.998047,323.837685 L770.152344,323.837685 L770.152344,337.367958 L783.730469,337.367958 L783.730469,332.306666 L797.738281,332.306666 L797.738281,320.473684 L827.970703,320.473684 L827.970703,343.128264 L838.130859,343.128264 L838.130859,323.837685 L848.734375,323.837685 L848.734375,334.925781 L879.84375,334.925781 L879.84375,323.837685 L896,323.837685 L896,337.265131 L910.806641,337.367958 L910.806641,328.805047 L917.65625,328.805047 L917.65625,347.079873 L935.251953,347.079873 L935.251953,334.925781 L953.740234,334.925781 L953.740234,323.837685 L1003.73242,323.837685 L1003.73242,340.771279 L1045,340.771279 L1045,321 C1045,318.238576 1042.76142,316 1040,316 Z",
      "id": "library_shelf_bg2_1",
      "fill": "#9F79A6"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "shelf5_3",
      "fill": "#BC99C3",
      "x": "955",
      "y": "203",
      "width": "100",
      "height": "302"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "shelf5_2",
      "fill": "#CCADD2",
      "x": "980",
      "y": "253",
      "width": "50",
      "height": "20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M989.84,267.888 C990.384003,267.888 990.839998,267.757335 991.208,267.496 C991.576002,267.234665 991.871999,266.882669 992.096,266.44 C992.320001,265.997331 992.482666,265.506669 992.584,264.968 C992.685334,264.429331 992.736,263.877336 992.736,263.312 C992.736,262.757331 992.685334,262.210669 992.584,261.672 C992.482666,261.133331 992.320001,260.642669 992.096,260.2 C991.871999,259.757331 991.576002,259.405335 991.208,259.144 C990.839998,258.882665 990.384003,258.752 989.84,258.752 C989.295997,258.752 988.840002,258.882665 988.472,259.144 C988.103998,259.405335 987.808001,259.757331 987.584,260.2 C987.359999,260.642669 987.197334,261.133331 987.096,261.672 C986.994666,262.210669 986.944,262.757331 986.944,263.312 C986.944,263.877336 986.994666,264.429331 987.096,264.968 C987.197334,265.506669 987.359999,265.997331 987.584,266.44 C987.808001,266.882669 988.103998,267.234665 988.472,267.496 C988.840002,267.757335 989.295997,267.888 989.84,267.888 Z M989.84,268.64 C989.12533,268.64 988.522669,268.482668 988.032,268.168 C987.541331,267.853332 987.146668,267.437336 986.848,266.92 C986.549332,266.402664 986.333334,265.829336 986.2,265.2 C986.066666,264.570664 986,263.941336 986,263.312 C986,262.682664 986.066666,262.056003 986.2,261.432 C986.333334,260.807997 986.549332,260.237336 986.848,259.72 C987.146668,259.202664 987.541331,258.786668 988.032,258.472 C988.522669,258.157332 989.12533,258 989.84,258 C990.55467,258 991.157331,258.157332 991.648,258.472 C992.138669,258.786668 992.533332,259.202664 992.832,259.72 C993.130668,260.237336 993.346666,260.807997 993.48,261.432 C993.613334,262.056003 993.68,262.682664 993.68,263.312 C993.68,263.941336 993.613334,264.570664 993.48,265.2 C993.346666,265.829336 993.130668,266.402664 992.832,266.92 C992.533332,267.437336 992.138669,267.853332 991.648,268.168 C991.157331,268.482668 990.55467,268.64 989.84,268.64 Z M1006.79,264.72 L1003.046,265.072 C1002.99267,264.933333 1002.966,264.778668 1002.966,264.608 C1002.966,264.458666 1002.982,264.336 1003.014,264.24 L1006.758,263.888 C1006.81133,264.026667 1006.838,264.181332 1006.838,264.352 C1006.838,264.501334 1006.822,264.624 1006.79,264.72 Z M1020.092,268.48 L1016.204,268.48 C1016.16133,268.416 1016.14,268.330667 1016.14,268.224 C1016.14,268.106666 1016.17733,268 1016.252,267.904 L1017.324,267.776 L1017.324,258.896 L1016.396,258.896 C1016.22533,258.896 1016.14,258.821334 1016.14,258.672 C1016.14,258.597333 1016.16667,258.469334 1016.22,258.288 L1016.252,258.16 L1020.236,258.16 C1020.908,258.16 1021.476,258.255999 1021.94,258.448 C1022.404,258.640001 1022.77733,258.890665 1023.06,259.2 C1023.34267,259.509335 1023.55067,259.847998 1023.684,260.216 C1023.81733,260.584002 1023.884,260.943998 1023.884,261.296 C1023.884,261.648002 1023.81733,262.007998 1023.684,262.376 C1023.55067,262.744002 1023.34267,263.082665 1023.06,263.392 C1022.77733,263.701335 1022.404,263.951999 1021.94,264.144 C1021.476,264.336001 1020.908,264.432 1020.236,264.432 L1018.22,264.432 L1018.22,267.744 L1019.948,267.744 C1020.11867,267.744 1020.204,267.818666 1020.204,267.968 C1020.204,268.042667 1020.17733,268.170666 1020.124,268.352 L1020.092,268.48 Z M1018.22,263.696 L1020.236,263.696 C1021.068,263.696 1021.72666,263.480002 1022.212,263.048 C1022.69734,262.615998 1022.94,262.032004 1022.94,261.296 C1022.94,260.559996 1022.69734,259.976002 1022.212,259.544 C1021.72666,259.111998 1021.068,258.896 1020.236,258.896 L1018.22,258.896 L1018.22,263.696 Z",
      "id": "shelf5_1",
      "fill": "#FFFFFF"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "shelf4_3",
      "fill": "#BC99C3",
      "x": "725",
      "y": "203",
      "width": "100",
      "height": "302"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "shelf4_2",
      "fill": "#CCADD2",
      "x": "750",
      "y": "253",
      "width": "50",
      "height": "20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M765.08,268.32 L761.992,268.32 C761.949333,268.256 761.928,268.170667 761.928,268.064 C761.928,267.946666 761.965333,267.84 762.04,267.744 L763.112,267.616 L763.112,259.408 L759.416,267.04 C759.309333,267.061333 759.192001,267.072 759.064,267.072 C758.935999,267.072 758.818667,267.061333 758.712,267.04 L755.016,259.6 L755.016,267.584 L755.944,267.584 C756.114668,267.584 756.2,267.658666 756.2,267.808 C756.2,267.882667 756.173334,268.010666 756.12,268.192 L756.088,268.32 L753.064,268.32 C753.021333,268.256 753,268.170667 753,268.064 C753,267.946666 753.037333,267.84 753.112,267.744 L754.184,267.616 L754.184,258.736 L753.256,258.736 C753.085332,258.736 753,258.661334 753,258.512 C753,258.437333 753.026666,258.309334 753.08,258.128 L753.112,258 L755.176,258 L759.112,265.904 L762.952,258 L765.128,258 C765.170667,258.064 765.192,258.149333 765.192,258.256 C765.192,258.373334 765.154667,258.48 765.08,258.576 L764.008,258.704 L764.008,267.584 L764.936,267.584 C765.106668,267.584 765.192,267.658666 765.192,267.808 C765.192,267.882667 765.165334,268.010666 765.112,268.192 L765.08,268.32 Z M778.318,264.56 L774.574,264.912 C774.520666,264.773333 774.494,264.618668 774.494,264.448 C774.494,264.298666 774.51,264.176 774.542,264.08 L778.286,263.728 C778.339334,263.866667 778.366,264.021332 778.366,264.192 C778.366,264.341334 778.35,264.464 778.318,264.56 Z M795.748,268.4 L789.684,259.424 L789.684,267.584 L790.612,267.584 C790.782668,267.584 790.868,267.658666 790.868,267.808 C790.868,267.882667 790.841334,268.010666 790.788,268.192 L790.756,268.32 L787.732,268.32 C787.689333,268.256 787.668,268.170667 787.668,268.064 C787.668,267.946666 787.705333,267.84 787.78,267.744 L788.852,267.616 L788.852,258.736 L787.924,258.736 C787.753333,258.736 787.668,258.661334 787.668,258.512 C787.668,258.437333 787.694667,258.309334 787.748,258.128 L787.78,258 L789.764,258 L795.556,266.576 L795.556,258.736 L794.628,258.736 C794.457333,258.736 794.372,258.661334 794.372,258.512 C794.372,258.437333 794.398667,258.309334 794.452,258.128 L794.484,258 L797.508,258 C797.550667,258.064 797.572,258.149333 797.572,258.256 C797.572,258.373334 797.534667,258.48 797.46,258.576 L796.388,258.704 L796.388,268.24 C796.292,268.282667 796.188001,268.317333 796.076,268.344 C795.964,268.370667 795.854667,268.389333 795.748,268.4 Z",
      "id": "shelf4_1",
      "fill": "#FFFFFF"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "shelf3_3",
      "fill": "#BC99C3",
      "x": "495",
      "y": "203",
      "width": "100",
      "height": "302"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "shelf3_2",
      "fill": "#CCADD2",
      "x": "520",
      "y": "253",
      "width": "50",
      "height": "20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M535.344,268.32 L532.176,268.32 C532.133333,268.256 532.112,268.170667 532.112,268.064 C532.112,267.946666 532.149333,267.84 532.224,267.744 L533.264,267.616 L530.032,262.768 L528.08,264.992 L528.08,267.584 L529.008,267.584 C529.178668,267.584 529.264,267.658666 529.264,267.808 C529.264,267.882667 529.237334,268.010666 529.184,268.192 L529.152,268.32 L526.064,268.32 C526.021333,268.256 526,268.170667 526,268.064 C526,267.946666 526.037333,267.84 526.112,267.744 L527.184,267.616 L527.184,258.736 L526.256,258.736 C526.085332,258.736 526,258.661334 526,258.512 C526,258.437333 526.026666,258.309334 526.08,258.128 L526.112,258 L529.2,258 C529.242667,258.064 529.264,258.149333 529.264,258.256 C529.264,258.373334 529.226667,258.48 529.152,258.576 L528.08,258.704 L528.08,263.936 L532.576,258.736 L531.728,258.736 C531.557332,258.736 531.472,258.661334 531.472,258.512 C531.472,258.437333 531.498666,258.309334 531.552,258.128 L531.584,258 L534.672,258 C534.714667,258.064 534.736,258.149333 534.736,258.256 C534.736,258.373334 534.698667,258.48 534.624,258.576 L533.616,258.704 L530.592,262.128 L534.32,267.584 L535.2,267.584 C535.370668,267.584 535.456,267.658666 535.456,267.808 C535.456,267.882667 535.429334,268.010666 535.376,268.192 L535.344,268.32 Z M546.966,264.56 L543.222,264.912 C543.168666,264.773333 543.142,264.618668 543.142,264.448 C543.142,264.298666 543.158,264.176 543.19,264.08 L546.934,263.728 C546.987334,263.866667 547.014,264.021332 547.014,264.192 C547.014,264.341334 546.998,264.464 546.966,264.56 Z M563.42,268.32 L556.38,268.32 C556.337333,268.256 556.316,268.170667 556.316,268.064 C556.316,267.946666 556.353333,267.84 556.428,267.744 L557.5,267.616 L557.5,258.736 L556.572,258.736 C556.401333,258.736 556.316,258.661334 556.316,258.512 C556.316,258.437333 556.342667,258.309334 556.396,258.128 L556.428,258 L559.676,258 C559.718667,258.064 559.74,258.149333 559.74,258.256 C559.74,258.373334 559.702667,258.48 559.628,258.576 L558.396,258.704 L558.396,267.584 L562.86,267.584 L563.26,265.76 C563.356001,265.685333 563.462666,265.648 563.58,265.648 C563.686667,265.648 563.772,265.669333 563.836,265.712 L563.804,267.904 C563.697333,268.064001 563.569334,268.202666 563.42,268.32 Z",
      "id": "shelf3_1",
      "fill": "#FFFFFF"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "shelf2_3",
      "fill": "#BC99C3",
      "x": "265",
      "y": "203",
      "width": "100",
      "height": "302"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "shelf2_2",
      "fill": "#CCADD2",
      "x": "290",
      "y": "253",
      "width": "50",
      "height": "20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M303.472,267.32 L300.064,267.32 C300.021333,267.256 300,267.170667 300,267.064 C300,266.946666 300.037333,266.84 300.112,266.744 L301.344,266.616 L301.344,257.736 L300.256,257.736 C300.085332,257.736 300,257.661334 300,257.512 C300,257.437333 300.026666,257.309334 300.08,257.128 L300.112,257 L303.52,257 C303.562667,257.064 303.584,257.149333 303.584,257.256 C303.584,257.373334 303.546667,257.48 303.472,257.576 L302.24,257.704 L302.24,266.584 L303.328,266.584 C303.498668,266.584 303.584,266.658666 303.584,266.808 C303.584,266.882667 303.557334,267.010666 303.504,267.192 L303.472,267.32 Z M316.55,263.56 L312.806,263.912 C312.752666,263.773333 312.726,263.618668 312.726,263.448 C312.726,263.298666 312.742,263.176 312.774,263.08 L316.518,262.728 C316.571334,262.866667 316.598,263.021332 316.598,263.192 C316.598,263.341334 316.582,263.464 316.55,263.56 Z M327.084,264.376 L327.084,257.736 L325.996,257.736 C325.825333,257.736 325.74,257.661334 325.74,257.512 C325.74,257.437333 325.766667,257.309334 325.82,257.128 L325.852,257 L329.26,257 C329.302667,257.064 329.324,257.149333 329.324,257.256 C329.324,257.373334 329.286667,257.48 329.212,257.576 L327.98,257.704 L327.98,264.104 C327.98,264.989338 327.886668,265.754663 327.7,266.4 C327.513333,267.045337 327.201336,267.621331 326.764,268.128 C326.326665,268.634669 325.745337,269.122664 325.02,269.592 C324.827999,269.431999 324.694667,269.245334 324.62,269.032 C325.249337,268.551998 325.742665,268.090669 326.1,267.648 C326.457335,267.205331 326.710666,266.722669 326.86,266.2 C327.009334,265.677331 327.084,265.069337 327.084,264.376 Z",
      "id": "shelf2_1",
      "fill": "#FFFFFF"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "shelf1_3",
      "fill": "#BC99C3",
      "x": "35",
      "y": "203",
      "width": "100",
      "height": "302"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "shelf1_2",
      "fill": "#CCADD2",
      "x": "60",
      "y": "253",
      "width": "50",
      "height": "20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.472,267.488 L71.472,264.176 L69.744,264.176 C69.5733325,264.176 69.488,264.101334 69.488,263.952 C69.488,263.877333 69.5146664,263.749334 69.568,263.568 L69.6,263.44 L73.408,263.44 C73.4506669,263.504 73.472,263.589333 73.472,263.696 C73.472,263.813334 73.434667,263.92 73.36,264.016 L72.368,264.144 L72.368,267.552 C72.3359998,267.626667 72.2933336,267.706666 72.24,267.792 C72.1866664,267.877334 72.1280003,267.957333 72.064,268.032 C71.6693314,268.213334 71.1920028,268.359999 70.632,268.472 C70.0719972,268.584001 69.525336,268.64 68.992,268.64 C67.9679949,268.64 67.0826704,268.424002 66.336,267.992 C65.5893296,267.559998 65.0133354,266.946671 64.608,266.152 C64.2026646,265.357329 64,264.416005 64,263.328 C64,262.250661 64.2053313,261.312004 64.616,260.512 C65.0266687,259.711996 65.602663,259.093336 66.344,258.656 C67.085337,258.218664 67.9626616,258 68.976,258 C69.4133355,258 69.8826642,258.053333 70.384,258.16 C70.8853358,258.266667 71.3493312,258.415999 71.776,258.608 C71.8400003,258.682667 71.8986664,258.762666 71.952,258.848 C72.0053336,258.933334 72.0479998,259.013333 72.08,259.088 L72.112,261.056 C72.0479997,261.098667 71.9626672,261.12 71.856,261.12 C71.7386661,261.12 71.6320005,261.082667 71.536,261.008 L71.104,259.168 C70.7306648,259.018666 70.3760017,258.912 70.04,258.848 C69.7039983,258.784 69.3493352,258.752 68.976,258.752 C68.1546626,258.752 67.440003,258.938665 66.832,259.312 C66.223997,259.685335 65.757335,260.215997 65.432,260.904 C65.106665,261.592003 64.944,262.405329 64.944,263.344 C64.944,264.272005 65.1119983,265.07733 65.448,265.76 C65.7840017,266.44267 66.2613302,266.967998 66.88,267.336 C67.4986698,267.704002 68.2293291,267.888 69.072,267.888 C69.4560019,267.888 69.8799977,267.848 70.344,267.768 C70.8080023,267.688 71.1839986,267.594667 71.472,267.488 Z M86.1820001,264.72 L82.4380001,265.072 C82.3846665,264.933333 82.3580001,264.778668 82.3580001,264.608 C82.3580001,264.458666 82.3739999,264.336 82.4060001,264.24 L86.1500001,263.888 C86.2033337,264.026667 86.2300001,264.181332 86.2300001,264.352 C86.2300001,264.501334 86.2140002,264.624 86.1820001,264.72 Z M105.372,268.48 L102.284,268.48 C102.241333,268.416 102.22,268.330667 102.22,268.224 C102.22,268.106666 102.257333,268 102.332,267.904 L103.404,267.776 L103.404,263.552 L97.6120002,263.552 L97.6120002,267.744 L98.5400002,267.744 C98.7106677,267.744 98.7960002,267.818666 98.7960002,267.968 C98.7960002,268.042667 98.7693338,268.170666 98.7160002,268.352 L98.6840002,268.48 L95.5960002,268.48 C95.5533333,268.416 95.5320002,268.330667 95.5320002,268.224 C95.5320002,268.106666 95.5693331,268 95.6440002,267.904 L96.7160002,267.776 L96.7160002,258.896 L95.7880002,258.896 C95.6173326,258.896 95.5320002,258.821334 95.5320002,258.672 C95.5320002,258.597333 95.5586666,258.469334 95.6120002,258.288 L95.6440002,258.16 L98.7320002,258.16 C98.774667,258.224 98.7960002,258.309333 98.7960002,258.416 C98.7960002,258.533334 98.7586672,258.64 98.6840002,258.736 L97.6120002,258.864 L97.6120002,262.816 L103.404,262.816 L103.404,258.896 L102.476,258.896 C102.305333,258.896 102.22,258.821334 102.22,258.672 C102.22,258.597333 102.246667,258.469334 102.3,258.288 L102.332,258.16 L105.42,258.16 C105.462667,258.224 105.484,258.309333 105.484,258.416 C105.484,258.533334 105.446667,258.64 105.372,258.736 L104.3,258.864 L104.3,267.744 L105.228,267.744 C105.398668,267.744 105.484,267.818666 105.484,267.968 C105.484,268.042667 105.457334,268.170666 105.404,268.352 L105.372,268.48 Z",
      "id": "shelf1_1",
      "fill": "#FFFFFF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2,505 L1282,505",
      "id": "library_ground",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "desk_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "1067",
      "y": "409",
      "width": "216",
      "height": "96"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1057,397 L1278,397 C1280.76142,397 1283,399.238576 1283,402 L1283,404 C1283,406.761424 1280.76142,409 1278,409 L1057,409 L1057,397 Z",
      "id": "desk_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(1170.000000, 403.000000) scale(-1, 1) translate(-1170.000000, -403.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1019.4422,447 L1062.5578,447 C1064.21466,447 1065.5578,448.343146 1065.5578,450 C1065.5578,450.13712 1065.5484,450.274078 1065.52967,450.409912 L1058,505 L1024,505 L1016.47033,450.409912 C1016.24394,448.768597 1017.39097,447.254525 1019.03228,447.028137 C1019.16812,447.009401 1019.30508,447 1019.4422,447 Z",
      "id": "trash_can",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "desk_computer_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "1206",
      "y": "316",
      "width": "77",
      "height": "63"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1247,358 C1257.61328,358 1265.0625,358 1272,358 C1275.62891,368.650391 1276.29688,386.232422 1272,397 C1252.54348,397 1242.52148,397 1235,397 C1244,388.804688 1253.312,375.5 1247,358 Z",
      "id": "desk_computer_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M945,384 L945,393 L946,393 C948.209139,393 950,394.790861 950,397 L920.071289,397 L920.071289,397 C920.032613,394.829882 921.760487,393.0393 923.930605,393.000624 C923.953946,393.000208 923.977291,393 924.000635,393 L925,393 L925,384 L945,384 Z",
      "id": "computer6_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M892,326 L977,326 C978.104569,326 979,326.895431 979,328 L979,382 C979,383.104569 978.104569,384 977,384 L892,384 C890.895431,384 890,383.104569 890,382 L890,328 C890,326.895431 890.895431,326 892,326 Z",
      "id": "computer6_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M898,332 L971,332 C972.104569,332 973,332.895431 973,334 L973,376 C973,377.104569 972.104569,378 971,378 L898,378 C896.895431,378 896,377.104569 896,376 L896,334 C896,332.895431 896.895431,332 898,332 Z",
      "id": "computer6_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M805,384 L805,393 L806,393 C808.209139,393 810,394.790861 810,397 L780.071289,397 L780.071289,397 C780.032613,394.829882 781.760487,393.0393 783.930605,393.000624 C783.953946,393.000208 783.977291,393 784.000635,393 L785,393 L785,384 L805,384 Z",
      "id": "computer5_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M752,326 L837,326 C838.104569,326 839,326.895431 839,328 L839,382 C839,383.104569 838.104569,384 837,384 L752,384 C750.895431,384 750,383.104569 750,382 L750,328 C750,326.895431 750.895431,326 752,326 Z",
      "id": "computer5_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M758,332 L831,332 C832.104569,332 833,332.895431 833,334 L833,376 C833,377.104569 832.104569,378 831,378 L758,378 C756.895431,378 756,377.104569 756,376 L756,334 C756,332.895431 756.895431,332 758,332 Z",
      "id": "computer5_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M665,384 L665,393 L666,393 C668.209139,393 670,394.790861 670,397 L640.071289,397 L640.071289,397 C640.032613,394.829882 641.760487,393.0393 643.930605,393.000624 C643.953946,393.000208 643.977291,393 644.000635,393 L645,393 L645,384 L665,384 Z",
      "id": "computer4_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M612,326 L697,326 C698.104569,326 699,326.895431 699,328 L699,382 C699,383.104569 698.104569,384 697,384 L612,384 C610.895431,384 610,383.104569 610,382 L610,328 C610,326.895431 610.895431,326 612,326 Z",
      "id": "computer4_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M618,332 L691,332 C692.104569,332 693,332.895431 693,334 L693,376 C693,377.104569 692.104569,378 691,378 L618,378 C616.895431,378 616,377.104569 616,376 L616,334 C616,332.895431 616.895431,332 618,332 Z",
      "id": "computer4_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M455,384 L455,393 L456,393 C458.209139,393 460,394.790861 460,397 L430.071289,397 L430.071289,397 C430.032613,394.829882 431.760487,393.0393 433.930605,393.000624 C433.953946,393.000208 433.977291,393 434.000635,393 L435,393 L435,384 L455,384 Z",
      "id": "computer3_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M402,326 L487,326 C488.104569,326 489,326.895431 489,328 L489,382 C489,383.104569 488.104569,384 487,384 L402,384 C400.895431,384 400,383.104569 400,382 L400,328 C400,326.895431 400.895431,326 402,326 Z",
      "id": "computer3_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M408,332 L481,332 C482.104569,332 483,332.895431 483,334 L483,376 C483,377.104569 482.104569,378 481,378 L408,378 C406.895431,378 406,377.104569 406,376 L406,334 C406,332.895431 406.895431,332 408,332 Z",
      "id": "computer3_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M315,384 L315,393 L316,393 C318.209139,393 320,394.790861 320,397 L290.071289,397 L290.071289,397 C290.032613,394.829882 291.760487,393.0393 293.930605,393.000624 C293.953946,393.000208 293.977291,393 294.000635,393 L295,393 L295,384 L315,384 Z",
      "id": "computer2_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M262,326 L347,326 C348.104569,326 349,326.895431 349,328 L349,382 C349,383.104569 348.104569,384 347,384 L262,384 C260.895431,384 260,383.104569 260,382 L260,328 C260,326.895431 260.895431,326 262,326 Z",
      "id": "computer2_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M268,332 L341,332 C342.104569,332 343,332.895431 343,334 L343,376 C343,377.104569 342.104569,378 341,378 L268,378 C266.895431,378 266,377.104569 266,376 L266,334 C266,332.895431 266.895431,332 268,332 Z",
      "id": "computer2_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M175,384 L175,393 L176,393 C178.209139,393 180,394.790861 180,397 L150.071289,397 L150.071289,397 C150.032613,394.829882 151.760487,393.0393 153.930605,393.000624 C153.953946,393.000208 153.977291,393 154.000635,393 L155,393 L155,384 L175,384 Z",
      "id": "computer1_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M122,326 L207,326 C208.104569,326 209,326.895431 209,328 L209,382 C209,383.104569 208.104569,384 207,384 L122,384 C120.895431,384 120,383.104569 120,382 L120,328 C120,326.895431 120.895431,326 122,326 Z",
      "id": "computer1_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128,332 L201,332 C202.104569,332 203,332.895431 203,334 L203,376 C203,377.104569 202.104569,378 201,378 L128,378 C126.895431,378 126,377.104569 126,376 L126,334 C126,332.895431 126.895431,332 128,332 Z",
      "id": "computer1_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "table_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "85",
      "y": "409",
      "width": "918",
      "height": "96"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "table_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(544.000000, 403.000000) scale(-1, 1) translate(-544.000000, -403.000000) ",
      "x": "75",
      "y": "397",
      "width": "938",
      "height": "12",
      "rx": "5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M925,440 L987,440 L987,450 L925,450 C922.238576,450 920,447.761424 920,445 L920,445 C920,442.238576 922.238576,440 925,440 Z",
      "id": "library_chair6_5",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M963,377 L976,377 C987.045695,377 996,385.954305 996,397 L996,412 C996,414.761424 993.761424,417 991,417 L948,417 C945.238576,417 943,414.761424 943,412 L943,397 C943,385.954305 951.954305,377 963,377 Z",
      "id": "library_chair6_4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "library_chair6_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "points": "927.25 450 930.75 450 930.75 501.318793 932 501.318793 932 505 926 505 926 501.317073 927.25 501.317073"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M987,397.000095 L987,397.000095 C987.966498,397.000095 988.75,397.783597 988.75,398.750095 L988.75,501.335046 L990,501.335046 L990,505 L984,505 L984,501.333337 L985.25,501.333337 L985.25,398.750095 C985.25,397.783597 986.033502,397.000095 987,397.000095 Z",
      "id": "library_chair6_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M955,397.000095 L955,397.000095 C955.966498,397.000095 956.75,397.783597 956.75,398.750095 L956.75,501.335046 L958,501.335046 L958,505 L952,505 L952,501.333337 L953.25,501.333337 L953.25,398.750095 C953.25,397.783597 954.033502,397.000095 955,397.000095 Z",
      "id": "library_chair6_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M754,440 L816,440 L816,450 L754,450 C751.238576,450 749,447.761424 749,445 L749,445 C749,442.238576 751.238576,440 754,440 Z",
      "id": "library_chair5_5",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(782.500000, 445.000000) scale(-1, 1) translate(-782.500000, -445.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M760,377 L773,377 C784.045695,377 793,385.954305 793,397 L793,412 C793,414.761424 790.761424,417 788,417 L745,417 C742.238576,417 740,414.761424 740,412 L740,397 C740,385.954305 748.954305,377 760,377 Z",
      "id": "library_chair5_4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(766.500000, 397.000000) scale(-1, 1) translate(-766.500000, -397.000000) "
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "library_chair5_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(807.000000, 477.500000) scale(-1, 1) translate(-807.000000, -477.500000) ",
      "points": "805.25 450 808.75 450 808.75 501.318793 810 501.318793 810 505 804 505 804 501.317073 805.25 501.317073"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M749,397.000095 L749,397.000095 C749.966498,397.000095 750.75,397.783597 750.75,398.750095 L750.75,501.335046 L752,501.335046 L752,505 L746,505 L746,501.333337 L747.25,501.333337 L747.25,398.750095 C747.25,397.783597 748.033502,397.000095 749,397.000095 Z",
      "id": "library_chair5_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(749.000000, 451.000000) scale(-1, 1) translate(-749.000000, -451.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M781,397.000095 L781,397.000095 C781.966498,397.000095 782.75,397.783597 782.75,398.750095 L782.75,501.335046 L784,501.335046 L784,505 L778,505 L778,501.333337 L779.25,501.333337 L779.25,398.750095 C779.25,397.783597 780.033502,397.000095 781,397.000095 Z",
      "id": "library_chair5_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(781.000000, 451.000000) scale(-1, 1) translate(-781.000000, -451.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M604,440 L666,440 L666,450 L604,450 C601.238576,450 599,447.761424 599,445 L599,445 C599,442.238576 601.238576,440 604,440 Z",
      "id": "library_chair4_5",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(632.500000, 445.000000) scale(-1, 1) translate(-632.500000, -445.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M610,377 L623,377 C634.045695,377 643,385.954305 643,397 L643,412 C643,414.761424 640.761424,417 638,417 L595,417 C592.238576,417 590,414.761424 590,412 L590,397 C590,385.954305 598.954305,377 610,377 Z",
      "id": "library_chair4_4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(616.500000, 397.000000) scale(-1, 1) translate(-616.500000, -397.000000) "
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "library_chair4_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(657.000000, 477.500000) scale(-1, 1) translate(-657.000000, -477.500000) ",
      "points": "655.25 450 658.75 450 658.75 501.318793 660 501.318793 660 505 654 505 654 501.317073 655.25 501.317073"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M599,397.000095 L599,397.000095 C599.966498,397.000095 600.75,397.783597 600.75,398.750095 L600.75,501.335046 L602,501.335046 L602,505 L596,505 L596,501.333337 L597.25,501.333337 L597.25,398.750095 C597.25,397.783597 598.033502,397.000095 599,397.000095 Z",
      "id": "library_chair4_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(599.000000, 451.000000) scale(-1, 1) translate(-599.000000, -451.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M631,397.000095 L631,397.000095 C631.966498,397.000095 632.75,397.783597 632.75,398.750095 L632.75,501.335046 L634,501.335046 L634,505 L628,505 L628,501.333337 L629.25,501.333337 L629.25,398.750095 C629.25,397.783597 630.033502,397.000095 631,397.000095 Z",
      "id": "library_chair4_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(631.000000, 451.000000) scale(-1, 1) translate(-631.000000, -451.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M394,440 L456,440 L456,450 L394,450 C391.238576,450 389,447.761424 389,445 L389,445 C389,442.238576 391.238576,440 394,440 Z",
      "id": "library_chair_3_5",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(422.500000, 445.000000) scale(-1, 1) translate(-422.500000, -445.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400,377 L413,377 C424.045695,377 433,385.954305 433,397 L433,412 C433,414.761424 430.761424,417 428,417 L385,417 C382.238576,417 380,414.761424 380,412 L380,397 C380,385.954305 388.954305,377 400,377 Z",
      "id": "library_chair_3_4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(406.500000, 397.000000) scale(-1, 1) translate(-406.500000, -397.000000) "
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "library_chair_3_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(447.000000, 477.500000) scale(-1, 1) translate(-447.000000, -477.500000) ",
      "points": "445.25 450 448.75 450 448.75 501.318793 450 501.318793 450 505 444 505 444 501.317073 445.25 501.317073"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M389,397.000095 L389,397.000095 C389.966498,397.000095 390.75,397.783597 390.75,398.750095 L390.75,501.335046 L392,501.335046 L392,505 L386,505 L386,501.333337 L387.25,501.333337 L387.25,398.750095 C387.25,397.783597 388.033502,397.000095 389,397.000095 Z",
      "id": "library_chair_3_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(389.000000, 451.000000) scale(-1, 1) translate(-389.000000, -451.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M421,397.000095 L421,397.000095 C421.966498,397.000095 422.75,397.783597 422.75,398.750095 L422.75,501.335046 L424,501.335046 L424,505 L418,505 L418,501.333337 L419.25,501.333337 L419.25,398.750095 C419.25,397.783597 420.033502,397.000095 421,397.000095 Z",
      "id": "library_chair_3_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(421.000000, 451.000000) scale(-1, 1) translate(-421.000000, -451.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M285,440 L347,440 L347,450 L285,450 C282.238576,450 280,447.761424 280,445 L280,445 C280,442.238576 282.238576,440 285,440 Z",
      "id": "library_chair2_5",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M323,377 L336,377 C347.045695,377 356,385.954305 356,397 L356,412 C356,414.761424 353.761424,417 351,417 L308,417 C305.238576,417 303,414.761424 303,412 L303,397 C303,385.954305 311.954305,377 323,377 Z",
      "id": "library_chair2_4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "library_chair2_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "points": "287.25 450 290.75 450 290.75 501.318793 292 501.318793 292 505 286 505 286 501.317073 287.25 501.317073"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M347,397.000095 L347,397.000095 C347.966498,397.000095 348.75,397.783597 348.75,398.750095 L348.75,501.335046 L350,501.335046 L350,505 L344,505 L344,501.333337 L345.25,501.333337 L345.25,398.750095 C345.25,397.783597 346.033502,397.000095 347,397.000095 Z",
      "id": "library_chair2_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M315,397.000095 L315,397.000095 C315.966498,397.000095 316.75,397.783597 316.75,398.750095 L316.75,501.335046 L318,501.335046 L318,505 L312,505 L312,501.333337 L313.25,501.333337 L313.25,398.750095 C313.25,397.783597 314.033502,397.000095 315,397.000095 Z",
      "id": "library_chair2_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M124,440 L186,440 L186,450 L124,450 C121.238576,450 119,447.761424 119,445 L119,445 C119,442.238576 121.238576,440 124,440 Z",
      "id": "library_chair1_5",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(152.500000, 445.000000) scale(-1, 1) translate(-152.500000, -445.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M130,377 L143,377 C154.045695,377 163,385.954305 163,397 L163,412 C163,414.761424 160.761424,417 158,417 L115,417 C112.238576,417 110,414.761424 110,412 L110,397 C110,385.954305 118.954305,377 130,377 Z",
      "id": "library_chair1_4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(136.500000, 397.000000) scale(-1, 1) translate(-136.500000, -397.000000) "
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "library_chair1_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(177.000000, 477.500000) scale(-1, 1) translate(-177.000000, -477.500000) ",
      "points": "175.25 450 178.75 450 178.75 501.318793 180 501.318793 180 505 174 505 174 501.317073 175.25 501.317073"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M119,397.000095 L119,397.000095 C119.966498,397.000095 120.75,397.783597 120.75,398.750095 L120.75,501.335046 L122,501.335046 L122,505 L116,505 L116,501.333337 L117.25,501.333337 L117.25,398.750095 C117.25,397.783597 118.033502,397.000095 119,397.000095 Z",
      "id": "library_chair1_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(119.000000, 451.000000) scale(-1, 1) translate(-119.000000, -451.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151,397.000095 L151,397.000095 C151.966498,397.000095 152.75,397.783597 152.75,398.750095 L152.75,501.335046 L154,501.335046 L154,505 L148,505 L148,501.333337 L149.25,501.333337 L149.25,398.750095 C149.25,397.783597 150.033502,397.000095 151,397.000095 Z",
      "id": "library_chair1_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(151.000000, 451.000000) scale(-1, 1) translate(-151.000000, -451.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1028,76 L1048,76 L1048,76 C1048,81.5228475 1043.52285,86 1038,86 L1038,86 C1032.47715,86 1028,81.5228475 1028,76 Z",
      "id": "light3_4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "light3_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "1003",
      "y": "71",
      "width": "70",
      "height": "5",
      "rx": "2.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1018,48 L1058,48 C1063.52285,48 1068,52.4771525 1068,58 L1068,76 L1008,76 L1008,58 C1008,52.4771525 1012.47715,48 1018,48 Z",
      "id": "light3_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "light3_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "points": "1036 0 1041 0 1041 48 1036 48"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M632,76 L652,76 L652,76 C652,81.5228475 647.522847,86 642,86 L642,86 C636.477153,86 632,81.5228475 632,76 Z",
      "id": "light2_4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "light2_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "607",
      "y": "71",
      "width": "70",
      "height": "5",
      "rx": "2.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M622,48 L662,48 C667.522847,48 672,52.4771525 672,58 L672,76 L612,76 L612,58 C612,52.4771525 616.477153,48 622,48 Z",
      "id": "light2_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "light2_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "points": "640 0 645 0 645 48 640 48"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M236,76 L256,76 L256,76 C256,81.5228475 251.522847,86 246,86 L246,86 C240.477153,86 236,81.5228475 236,76 Z",
      "id": "light1_4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "light1_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "211",
      "y": "71",
      "width": "70",
      "height": "5",
      "rx": "2.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M226,48 L266,48 C271.522847,48 276,52.4771525 276,58 L276,76 L216,76 L216,58 C216,52.4771525 220.477153,48 226,48 Z",
      "id": "light1_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "light1_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "points": "244 0 249 0 249 48 244 48"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "window4_8",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "1098",
      "y": "41",
      "width": "185",
      "height": "121"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "window4_7",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "1102.80836",
      "y": "46",
      "width": "129.825784",
      "height": "111"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1232.63415,67 L1198.01394,111",
      "id": "window4_6",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1232.63415,46 L1164.3554,135",
      "id": "window4_5",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1193.20557,68 L1124.92683,157",
      "id": "window4_4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "window4_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "1238.40418",
      "y": "46",
      "width": "44.7900009",
      "height": "111"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1363.4216,46 L1328.80139,90",
      "id": "window4_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1282.19204,108.698037 L1245.13589,157",
      "id": "window4_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "window3_9",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "702",
      "y": "41",
      "width": "276",
      "height": "121"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "window3_8",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "706.808362",
      "y": "46",
      "width": "129.825784",
      "height": "111"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M836.634146,67 L802.013937,111",
      "id": "window3_7",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M836.634146,46 L768.355401,135",
      "id": "window3_6",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M797.205575,68 L728.926829,157",
      "id": "window3_5",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "window3_4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "842.404181",
      "y": "46",
      "width": "129.825784",
      "height": "111"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M967.421603,46 L932.801394,90",
      "id": "window3_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M952.034843,46 L883.756098,135",
      "id": "window3_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M917.414634,68 L849.135889,157",
      "id": "window3_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "window2_9",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "306",
      "y": "41",
      "width": "276",
      "height": "121"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "window2_8",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "310.808362",
      "y": "46",
      "width": "129.825784",
      "height": "111"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M440.634146,67 L406.013937,111",
      "id": "window2_7",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M440.634146,46 L372.355401,135",
      "id": "window2_6",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M401.205575,68 L332.926829,157",
      "id": "window2_5",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "window2_4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "446.404181",
      "y": "46",
      "width": "129.825784",
      "height": "111"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M571.421603,46 L536.801394,90",
      "id": "window2_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M556.034843,46 L487.756098,135",
      "id": "window2_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M521.414634,68 L453.135889,157",
      "id": "window2_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "window1_9",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "1",
      "y": "41",
      "width": "185",
      "height": "121"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "window1_8",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "0.568765202",
      "y": "46",
      "width": "44.0699997",
      "height": "111"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44.6341463,67 L10.0139373,111",
      "id": "window1_7",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M44.6341463,46 L1.5687652,102.134876",
      "id": "window1_6",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "window1_4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "50.4041812",
      "y": "46",
      "width": "129.825784",
      "height": "111"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M175.421603,46 L140.801394,90",
      "id": "window1_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M160.034843,46 L91.7560976,135",
      "id": "window1_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M125.414634,68 L57.1358885,157",
      "id": "window1_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-320f7c28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_5/svg/scene/backgrounds/library_background.vue
// module id = 792
// module chunks = 1